import { render, staticRenderFns } from "./fanganys.vue?vue&type=template&id=8489d92c&scoped=true&"
import script from "./fanganys.vue?vue&type=script&lang=js&"
export * from "./fanganys.vue?vue&type=script&lang=js&"
import style0 from "./fanganys.vue?vue&type=style&index=0&id=8489d92c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8489d92c",
  null
  
)

export default component.exports